import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayComponent } from './overlay.component';
import { OverlayDirectiveDirective } from './overlay-directive.directive';



@NgModule({
    declarations: [
        OverlayComponent,
        OverlayDirectiveDirective
    ],
    exports: [
        OverlayComponent
    ],
    imports: [
        CommonModule
    ]
})
export class OverlayModule { }
